import { FilterType, FilterState } from '../helpers/common-types';
import { filterTypes } from '../helpers/filter-helpers';

type QueryStringState = {
    currentDate?: string,
    currentAppliedFilters?: FilterState
}

export const getStateFromQueryString = () => {
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);

    let filterSettings: FilterState = {
        [FilterType.LOCATION]: { value: urlParams.get(FilterType.LOCATION)?.split(",") || [""]},
        [FilterType.CATEGORIES]: { value: urlParams.get(FilterType.CATEGORIES)?.split(",") || [""] },
        [FilterType.NAME]: { value: urlParams.get(FilterType.NAME)?.split(",") || [""] }
    }

    return {
        ...(urlParams.has('date') && { currentDate: urlParams.get('date') }),
        currentAppliedFilters: filterSettings
    } as QueryStringState;
}

export const writeStateToUrl = (currentDate?: string, currentAppliedFilters?: FilterState) => {
    // The current date and filter settings are mutually exclusive in a query string.
    // You can try to use both, but they'll contradict since the filter setting sets the date to the first occurrence.

    const baseUrl = window.location.origin + window.location.pathname;
    if (!!currentDate) {
        return `${baseUrl}?date=${currentDate}`;
    }

    let filterQuery: string[] = [];
    if (!!currentAppliedFilters) {
        filterTypes.forEach(filterType => {
            const filterValue = currentAppliedFilters[filterType].value;
            if (filterValue.join() !== "") {
                filterQuery.push(`${filterType}=${filterValue.join(",")}`);
            }
        })
        return `${baseUrl}?${filterQuery.join("&")}`;
    }

    return baseUrl;
}